import { Controller } from "@hotwired/stimulus"
import tippy, { delegate } from "tippy.js"

export default class extends Controller {
  connect() {
    tippy.setDefaultProps({ theme: "buezli", arrow: false, allowHTML: true, animation: "fade", duration: [0, 150], offset: [0, 6] })
    this.instances = delegate(this.element, { target: "[data-tippy-content]" })
  }

  disconnect() {
    const instances = Array.isArray(this.instances) ? this.instances : [this.instances]
    instances.filter(Boolean).forEach((instance) => instance.destroy())
  }
}
